import {showStatusesByPeriodExportLoading, setStatusesByPeriodLoading} from "../actions/actionsStatusesByPeriodList";
import {API_URL} from "../config";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {GET_NOTIFICATION_ERROR} from "../types/types";
import {setUserError} from "../actions/actionsUsersList";
import {hideError, hideErrorMessage} from "../actions/actions";
import {GET_STATUSES_BY_PERIOD_LIST, GET_STATUSES_BY_PERIOD_PAGINATION, SET_USER_STATUS_SUCCESS, GET_FILES_HISTORY, SET_FILES_HISTORY_LOADER, GET_FILES_PAGINATION} from "../types/typesStatusesByPeriodList";
import axios from "axios";

export function getStatusesByPeriodWithPaginationFilterAndSorting(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setStatusesByPeriodLoading(true))
        axios.post(`${API_URL}Statistic/GetUserStatusStatisticPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_STATUSES_BY_PERIOD_LIST, payload: response.data.data.items})
                dispatch({type: GET_STATUSES_BY_PERIOD_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(setStatusesByPeriodLoading(false))
            })
    }
}

export function generateStatusesByPeriodExcel(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(showStatusesByPeriodExportLoading(true));
        axios.post(`${API_URL}Statistic/GenerateStatistic?type=3`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showStatusesByPeriodExportLoading(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null})
                return dispatch(setUserError(false));
            })
    }
}

export function deleteAllFiles(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showStatusesByPeriodExportLoading(true));
        axios.delete(`${API_URL}Statistic/DeleteAllFiles`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch({type: GET_FILES_HISTORY, payload: null});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showStatusesByPeriodExportLoading(false));
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function deleteFileById(id: number | any, dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showStatusesByPeriodExportLoading(true));
        axios.delete(`${API_URL}Statistic/DeleteFileById?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch(getFilesHistory(dataSort, jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showStatusesByPeriodExportLoading(false));
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function getFilesHistory(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SET_FILES_HISTORY_LOADER, payload: true})
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        axios.post(`${API_URL}Statistic/GetFilesHistory`, dataSort,{
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_FILES_HISTORY, payload: response.data.data.items});
                dispatch({type: GET_FILES_PAGINATION, payload: response.data.data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_FILES_HISTORY_LOADER, payload: false});
                dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
            })
    }
}
export function getStatusesByPeriodExcelByLink(id: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showStatusesByPeriodExportLoading(true));

        axios.get(`${API_URL}Statistic/GetTempUrlFile?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                const fileUrl = response.data.data;
                const fileName = response.data.title || 'export.xlsx';

                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    dispatch(setUserError(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showStatusesByPeriodExportLoading(false));
                dispatch(showAccessDeniedNotifications(false));
                dispatch(setUserError(false));
            });
    }
}
